import type { GetOneResponseCustomPricing } from "@classes-service-types/index.ts";
import type { UseQueryOptions } from "@tanstack/vue-query";
import { useQuery } from "@tanstack/vue-query";
import type { AxiosResponse } from "axios";
import { computed, type Ref, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";

export const getQueryKey = (id: string) => ["getCustomPricingOne", id];

export const useGetCustomPricingOne = <TData = GetOneResponseCustomPricing>(
  overrideId: Ref<string | undefined>,
  useQueryOptions?: Partial<UseQueryOptions<GetOneResponseCustomPricing, Error, TData>>,
) => {
  const fetchCustomPricingOne = (): Promise<GetOneResponseCustomPricing> => {
    return learningServiceRequest({
      method: "get",
      url: `/custom_pricing/${unref(overrideId)}/`,
    }).then((response: AxiosResponse<GetOneResponseCustomPricing>) => response.data);
  };

  return useQuery<GetOneResponseCustomPricing, Error, TData>({
    queryKey: computed(() => getQueryKey(unref(overrideId) ?? "")),
    queryFn: fetchCustomPricingOne,
    ...useQueryOptions,
  });
};
